/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useCusLineStore = defineStore("cusline", {
    actions: {
        async cusLineListFetch(payload) {
            const body = {
                page: {
                    index: payload.index,
                    size: payload.size,
                    sort: "",
                },
                filter: {
                    cusUid: payload.cusUid,
                    userId: "",
                    shopUid: payload.shopUid,
                    groupUid: payload.groupUid
                },
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/cus-svc/profile/lines/list";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async cusLineInfoFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/cus-svc/profile/lines/info/" + payload.uid;
                    const response = http.get(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async cusLineDeleteFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/cus-svc/profile/lines/delete/" + payload.uid;
                    const response = http.delete(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },
    },
});